import api from '.';

export function listar({ start = 0, size = 10, filters = '[]', filtersMode = '{}', globalFilter = '', sorting = '[]' } = {}) {
    return api.get('/fiscalXmlObservacao/listar', {
        params: {
            start,
            size,
            filters,
            filtersMode,
            globalFilter,
            sorting,
        },
    });
}

export function consultar(uuid) {
    return api.get(`/fiscalXmlObservacao/edit/${uuid}`);
}

export function ignorar(uuid, motivo) {
    return api.patch(`/fiscalXmlObservacao/ignorar/${uuid}`, { motivo });
}

export function vincular(uuid, produtoId) {
    return api.patch(`/fiscalXmlObservacao/vincular/${uuid}`, {
        produtoId,
    });
}

export function aplicar(uuid, motivo) {
    return api.patch(`/fiscalXmlObservacao/aplicar/${uuid}`, {
        motivo,
    });
}
